import { React, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from "react-redux";
import AutosuggestComponent from './AutosuggestComponent';

import { encoded } from '../../../utils/cryptoUtils';

import { GetAutoSuggestions, GetCustomerOutstandingReceiptData, GetCustomerOutstandingPaymentData } from '../../../redux/actions/Admin'; // Redux action

const CustomerAutosuggest = ({
    style,
    input_style,
    label,
    type,
    placeholder,
    name,
    field_name,
    value,
    onChange,
    required,
    hidden,
    disabled,
    display,
    setFormData
}) => {
    const dispatch = useDispatch();
    const autoSuggestionList = useSelector((state) => state.admin.autoSuggestionList || []);
    const customerData = useSelector((state) => state.admin.customerData || {});
    const [suggestions1, setSuggestions1] = useState([]);

    const escapeRegexCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const getCustomerOutstandingPaymentData = (value) => {
        dispatch(GetCustomerOutstandingPaymentData(encoded(JSON.stringify({ customer_id: value }))));
    };

    const getCustomerOutstandingReceiptData = (value) => {
        dispatch(GetCustomerOutstandingReceiptData(encoded(JSON.stringify({ customer_id: value }))));
    };

    const getSuggestions1 = (value) => {
        if (!value || typeof value !== "string") {
            return [];
        }

        setFormData((prev) => ({
            ...prev,
            pending_amount: '',
            invoiceNosList: [],
            customer: {}, // Clears customer when input is empty
        }));

        setFormData((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                company_name: value,
            },
        }));
        return autoSuggestionList.filter((user) => {
            const customerObject = user.customObject || {}; // Ensure object exists
            const address = customerObject.address || {}; // Ensure address exists

            const itemData = `${customerObject.company_name?.toUpperCase() || ""} 
                              ${customerObject.gst_number?.toUpperCase() || ""} 
                              ${address.mobile_number1?.toUpperCase() || ""} 
                              ${address.mobile_number2?.toUpperCase() || ""} 
                              ${address.email_id?.toUpperCase() || ""}`.trim();

            const textData = escapeRegexCharacters(value.trim().toUpperCase());

            return itemData.includes(textData);
        });
    };

    const getSuggestionValue1 = (suggestion) => suggestion?.customObject?.company_name || "";

    const onChange1 = (event, { newValue }) => {
        setFormData((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                company_name: newValue,
            },
        }));
    };

    const onSuggestionsFetchRequested1 = ({ value, reason }) => {
        if (!value || typeof value !== "string") return;
        if (reason === "input-changed") {
            let newData = getSuggestions1(value);
            if (newData?.length === 0 && value?.length > 1) {
                dispatch(GetAutoSuggestions(
                    encoded(
                        JSON.stringify({
                            branch_id: localStorage.getItem("branch_id_1"),
                            object_type: "Customer",
                            type_of_entity: field_name === "customer_name" ? "CS" : field_name === "dealer_name" ? "DL" : field_name === "merchant_name" ? "MR" : "DS",
                            search_value: value,
                        })
                    )
                )); // Redux call
            }
            setSuggestions1(newData);
        }
    };

    useEffect(() => {
        if (autoSuggestionList.length !== suggestions1.length) {
            setSuggestions1(autoSuggestionList);
        }
    }, [autoSuggestionList]);

    useEffect(() => {
        if (!customerData) return;
        if (value && customerData && Object.keys(customerData).length > 0) {
            if (field_name === "customer_name") {
                setFormData((prev) => ({
                    ...prev,
                    pending_amount: customerData?.receivable_amount || '',
                    invoiceNosList: customerData?.receivable_list || [],
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    pending_amount: customerData?.payable_amount || '',
                    invoiceNosList: customerData?.payable_list || [],
                }));
            }
        }
    }, [customerData]);


    const onSuggestionsClearRequested1 = () => {
        setSuggestions1([]);
    };

    const onSuggestionSelected1 = (event, { suggestion }) => {
        event.preventDefault();

        if (!suggestion || !suggestion.customObject) {
            return;
        }

        const selectedCustomer = suggestion.customObject;
        console.log("Selected Customer:", selectedCustomer);

        if (field_name === "customer_name") {
            getCustomerOutstandingReceiptData(selectedCustomer.customer_id);
        } else {
            getCustomerOutstandingPaymentData(selectedCustomer.customer_id);
        }

        setFormData((prev) => ({
            ...prev,
            customer: {
                ...selectedCustomer,
                address: {
                    ...prev.customer?.address,
                    ...selectedCustomer?.address,
                },
                bank: {
                    ...prev.customer?.bank,
                    ...selectedCustomer?.bank,
                },
            },
        }));
    };

    const onBlur1 = (event, { highlightedSuggestion }) => {
        if (!highlightedSuggestion || !highlightedSuggestion.customObject) {
            return;
        }

        const selectedCustomer = highlightedSuggestion.customObject;
        console.log("Highlighted Customer:", selectedCustomer);

        if (field_name === "customer_name") {
            getCustomerOutstandingReceiptData(selectedCustomer.customer_id);
        } else {
            getCustomerOutstandingPaymentData(selectedCustomer.customer_id);
        }

        setFormData((prev) => ({
            ...prev,
            customer: {
                ...selectedCustomer,
                address: {
                    ...prev.customer?.address,
                    ...selectedCustomer?.address,
                },
                bank: {
                    ...prev.customer?.bank,
                    ...selectedCustomer?.bank,
                },
            },
        }));
    };


    return (
        <AutosuggestComponent
            style={style}
            input_style={input_style}
            label={label}
            type={type}
            placeholder="Customers..."
            required={required}
            name={name}
            value={value}
            hidden={hidden}
            disabled={disabled}
            display={display}
            suggestions={suggestions1}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested1}
            onSuggestionSelected={onSuggestionSelected1}
            onSuggestionsClearRequested={onSuggestionsClearRequested1}
            getSuggestionValue={getSuggestionValue1}
            onChange={onChange1}
            onBlur={onBlur1}
        />
    );
};

CustomerAutosuggest.propTypes = {
    style: PropTypes.string,
    input_style: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    display: PropTypes.bool,
    setFormData: PropTypes.func,
}

export default CustomerAutosuggest;
